<template>
  <side-drawer :title="$t('map.layers')" :model-value="true" @update:model-value="emit('closed')">
    <slot name="filter">
      <v-list>
        <!-- GIS -->
        <v-list-group v-if="organizationSettings?.geoLayersGIS">
          <template #activator="{ props: itemProps }">
            <v-list-item v-bind="itemProps">
              <template #title>
                <span>Gis layers</span>
                <v-badge v-if="layersGis.length" inline color="error" :content="layersGis.length" />
              </template>
            </v-list-item>
          </template>

          <template #default>
            <v-list-item v-for="layer of availableGISLayers" :key="layer.key" class="py-0">
              <v-checkbox
                v-model="layersGis"
                hide-details
                density="comfortable"
                :label="$te(`geoLayersGIS.${layer.key}`) ? $t(`geoLayersGIS.${layer.key}`) : layer.name"
                :value="layer.key"
              />
            </v-list-item>
          </template>
        </v-list-group>

        <!-- DUOPP -->
        <v-list-group v-if="organizationSettings?.geoLayersDuoPP">
          <template #activator="{ props: itemProps }">
            <v-list-item v-bind="itemProps">
              <template #title>
                <span>Duopp GWSW</span>
                <v-badge v-if="layersDuopp.length" inline color="error" :content="layersDuopp.length" />
              </template>
            </v-list-item>
          </template>

          <template #default>
            <v-list-item v-for="layer of availableDuoppLayers" :key="layer.key" class="py-0">
              <v-checkbox
                v-model="layersDuopp"
                hide-details
                density="comfortable"
                :label="$te(`geoLayersDuoPP.${layer.key}`) ? $t(`geoLayersDuoPP.${layer.key}`) : layer.name"
                :value="layer.key"
              />
              <v-img
                v-if="layersDuopp.includes(layer.key)"
                :src="generateLayerLegendUrl(layer.key, duoppKey)"
                :alt="`Legend: ${layer.name}`"
                width="auto"
              />
            </v-list-item>
          </template>
        </v-list-group>

        <!-- PDOK -->
        <v-list-group v-if="organizationSettings?.geoLayers">
          <template #activator="{ props: itemProps }">
            <v-list-item v-bind="itemProps">
              <template #title>
                <span>PDOK</span>
                <v-badge v-if="layersPdok.length" inline color="error" :content="layersPdok.length" />
              </template>
            </v-list-item>
          </template>

          <template #default>
            <v-list-item v-for="layer of pdokLayers" :key="layer" class="py-0">
              <v-checkbox
                v-model="layersPdok"
                hide-details
                density="comfortable"
                :label="$te(`geoLayers.${layer}`) ? $t(`geoLayers.${layer}`) : layer"
                :value="layer"
              />
              <v-img
                v-if="layersPdok.includes(layer)"
                :src="generateLayerLegendUrl(layer, undefined, $t(`geoLayers.${layer}`))"
                :alt="`Legend: ${layer}`"
                width="auto"
              />
            </v-list-item>
          </template>
        </v-list-group>
      </v-list>
    </slot>
  </side-drawer>
</template>

<script setup lang="ts">
const authStore = useAuthStore()
const { currentOrganization } = storeToRefs(authStore)

const layersPdok = useLocalStorage<Array<string>>("ol:layer-pdok", [])
const layersDuopp = useLocalStorage<Array<string>>(`ol-${currentOrganization.value}:layer-duopp`, [])
const layersGis = useLocalStorage<Array<string>>(`ol-${currentOrganization.value}:layer-gis`, [])

const { organizationSettings } = defineProps<{
  organizationSettings: OrganizationSettings
}>()

const emit = defineEmits<{
  (e: "closed"): void
}>()

const availableDuoppLayers = computed(() => organizationSettings.geoDuoPPCategories.filter((layer) => layer.enabled) ?? [])
const availableGISLayers = computed(() => organizationSettings.geoGISCategories?.filter((layer) => layer.enabled) ?? [])
const duoppKey = computed(() => organizationSettings.geoLayersDuoPPOrganizationName)
</script>
